import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import { TranscriptResults } from '../transcriptTypes';

export const TranscriptSentenceKeywordsAndImportantPhrases = ({ item }: { item: TranscriptResults }) => {
  const { t } = useTranslation('components', { keyPrefix: 'transcript' });

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Typography variant="text2">{item.text}</Typography>
      <Typography variant="text3" minWidth={88} ml={5} textAlign="right" color="grey.500">
        {t('keywords', { postProcess: 'interval', count: Number(item.count) })}
      </Typography>
    </Box>
  );
};
